
















import { DomainEnum } from '../../enums';

export default {
  name: 'domain-selector',
  props: {
    domains: {
      type: Array,
      required: true
    },
    selectedDomain: {
      type: String,
      required: true
    },
    disabled: Boolean
  },
  computed: {
    selectedMarkStyle: function () {
      const percentageWidth = (100 / this.domains.length);
      return {
        width: `${percentageWidth}%`,
        left: `${(percentageWidth * this.domains.indexOf(this.selectedDomain))}%`
      };
    }
  },
  methods: {
    getDomainIcon: function (domain: DomainEnum): string {
      return {
        [DomainEnum.SEARCH]: 'searchdomain',
        [DomainEnum.BROWSE]: 'navigationdomain'
      }[domain];
    }
  }
};

